import { cn } from '../../lib/cn';
import type { BriefingRow } from '../../executiveintel/framework';

type Props = { briefings?: BriefingRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'ready': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'scheduled': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function AIExecutiveBriefingsPanel({ briefings = [] }: Props) {
  return (
    <div className="space-y-2">
      {briefings.map((b) => (
        <div key={b.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <span className="rounded bg-brand-100 px-1.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {b.type}
            </span>
            <p className="mt-1 text-sm font-medium">{b.title}</p>
            <p className="text-xs text-slate-500">{b.insights} insights</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(b.status))}>
            {b.status}
          </span>
        </div>
      ))}
    </div>
  );
}
